var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container activity-details-container",class:{'subject-container':_vm.isSubject}},[(!_vm.isSubject)?[_c('List',{attrs:{"name":_vm.dName}})]:[_c('Subject',{attrs:{"name":_vm.dName}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }